module.exports = __webpack_public_path__ + "img/case4-1.3565c8cf.jpg";